// src/utils/types.ts
var PageType = /* @__PURE__ */ ((PageType2) => {
  PageType2["Search"] = "search";
  PageType2["Browse"] = "browse";
  PageType2["Promo"] = "promo";
  PageType2["ValueDeal"] = "valuedeal";
  return PageType2;
})(PageType || {});
var Brand = /* @__PURE__ */ ((Brand3) => {
  Brand3["Very"] = "very";
  Brand3["Littlewoods"] = "littlewoods";
  Brand3["VeryIE"] = "veryireland";
  return Brand3;
})(Brand || {});
var Sort = /* @__PURE__ */ ((Sort2) => {
  Sort2["Relevance"] = "relevance";
  Sort2["Brand"] = "brand";
  Sort2["HighestRated"] = "highestrated";
  Sort2["NewIn"] = "newin";
  Sort2["PriceDesc"] = "pricedesc";
  Sort2["Price"] = "price";
  return Sort2;
})(Sort || {});

// src/utils/api-url.ts
var APIQueryParamKeys = {
  GroupId: "filters[group_id]",
  NumProducts: "num_results_per_page",
  Page: "page",
  SortBy: "sort_by",
  SortOrder: "sort_order",
  UI: "ui"
};
var IMPORTANT_UF = ["priceType"];
var AMPERSAND_TEMP_REPLACEMENT = "@&@";
var AMPERSAND_TEMP_REGEX = new RegExp(AMPERSAND_TEMP_REPLACEMENT, "g");
var PLUS_TEMP_REPLACEMENT = "@+@";
var PLUS_TEMP_REGEX = /@\+@/g;
var SLASH_TEMP_REPLACEMENT = "@/@";
var SLASH_TEMP_REGEX = new RegExp(SLASH_TEMP_REPLACEMENT, "g");
var AMPERSAND_REGEX = /&/g;
var PLUS_REGEX = /\+/g;
var replaceSpecialChars = (text) => text.replace(AMPERSAND_REGEX, AMPERSAND_TEMP_REPLACEMENT).replace(PLUS_REGEX, PLUS_TEMP_REPLACEMENT).replace(SLASH_CHAR_REGEX, SLASH_TEMP_REPLACEMENT);
var encodeSpecialChars = (text) => encodeURI(text).replace(AMPERSAND_TEMP_REGEX, "%26").replace(PLUS_TEMP_REGEX, "%2B").replace(SLASH_TEMP_REGEX, "%2F");
var PageTypeFilterMap = {
  ["browse" /* Browse */]: "group_id",
  ["promo" /* Promo */]: "collection_id",
  ["valuedeal" /* ValueDeal */]: "collection_id",
  ["search" /* Search */]: ""
};
var getFilterName = (type) => PageTypeFilterMap[type];
var SortOptionsMap = {
  ["relevance" /* Relevance */]: { sortBy: "relevance", sortOrder: "descending" },
  ["brand" /* Brand */]: { sortBy: "brand_name", sortOrder: "ascending" },
  ["highestrated" /* HighestRated */]: { sortBy: "rating", sortOrder: "descending" },
  ["newin" /* NewIn */]: { sortBy: "new_in", sortOrder: "descending" },
  ["pricedesc" /* PriceDesc */]: { sortBy: "price", sortOrder: "descending" },
  ["price" /* Price */]: { sortBy: "price", sortOrder: "ascending" }
};
var getSortOptions = (sort) => {
  if (!sort) return;
  const opts = SortOptionsMap[sort];
  if (!opts) return;
  return opts;
};
var getFilterValue = (plpURL) => {
  var _a;
  if (plpURL.isBrowse) return (_a = plpURL.category) == null ? void 0 : _a.id;
  if (plpURL.isPromo) return plpURL.pageName;
  if (plpURL.isValueDeal) return plpURL.pageName;
  return plpURL.searchTerm;
};
var getFilterPart = (plpURL) => {
  const filterName = getFilterName(plpURL.type);
  const filterValue = getFilterValue(plpURL);
  return [...!filterName ? [] : [filterName], filterValue].join("/");
};
var getGroupId = (plpURL) => {
  var _a;
  if (!((_a = plpURL.category) == null ? void 0 : _a.id)) return;
  if (plpURL.isBrowse && !plpURL.unfilteredFacet) return;
  if (!plpURL.isBrowse && plpURL.category.id === "all") return;
  return replaceSpecialChars(plpURL.category.id);
};
var getCustomerId = (customerId) => {
  if (typeof window === "undefined") return customerId;
  return window.cnstrcUserId;
};
var TRAILING_SLASH_REGEX = /\/$/;
var trimTrailingSlash = (url) => url.replace(TRAILING_SLASH_REGEX, "");

// src/utils/consts.ts
var EQ_SEARCH_REGEX = /^\/e\/q\/(.+)\.end/;
var BROWSE_REGEX = /\/browse\//;
var PROMO_REGEX = /\/promo\//;
var SEARCH_REGEX = /\/search\//;
var PAGE_TYPE_REGEX = /^\/(?<type>browse|promo|search|valuedeal)\/?/;
var FACET_REGEX = /(?<facetId>.+\w)(?<facetType>---?)(?<facetOptions>.+)/;
var DASH_CHAR_REGEX = /-/g;
var SLASH_CHAR_REGEX = /\//g;
var SPACE_REGEX = /\s+/g;
var DEFAULT_BRAND_SITE = "very" /* Very */;
var DEFAULT_NUM_PRODUCTS = 30;
var FALLBACK_URL_BASE = "https://example.com";
var DEFAULT_FACET_SEPARATOR = "--";
var RANGE_FACET_SEPARATOR = "---";
var FACET_OPTION_SEPARATOR = "+";
var RANGE_FACETS = ["price", "screenSize", "microwaveCapacity", "discount", "dryLoad", "washLoad"];
var VALID_BRAND_MAP = {
  ["very" /* Very */]: "very" /* Very */,
  ["veryireland" /* VeryIE */]: "veryireland" /* VeryIE */,
  ["littlewoods" /* Littlewoods */]: "littlewoods" /* Littlewoods */
};
var BRAND_DOMAIN_MAP = {
  ["very" /* Very */]: "https://www.very.co.uk",
  ["veryireland" /* VeryIE */]: "https://www.very.ie",
  ["littlewoods" /* Littlewoods */]: "https://www.littlewoods.com"
};
var QueryParamKeys = {
  Sort: "sortkey",
  Page: "page",
  NumProducts: "numProducts",
  UF: "uf"
};

// src/utils/helpers.ts
var FROM_SEO_FACET_ID_REGEX = /-([a-z])/g;
var fromSEOFacetId = (str) => decodeURIComponent(str).replace(FROM_SEO_FACET_ID_REGEX, (g) => g[1].toUpperCase());
var FLOAT_NUM_REGEX = /(\d+)-(\d+)/g;
var FROM_AND_ABOVE_REGEX = /^([\d.]+)-and-above$/;
var FROM_UP_TO_REGEX = /^up-to-([\d.]+)$/;
var FROM_FROM_TO_REGEX = /^([\d.]+)-to-([\d.]+)$/;
var FROM_SLASH_REGEX = /-slash-/g;
var fromSEOFacetOptionId = (str, isRangeFacet) => {
  if (isRangeFacet) {
    return str.replace(FLOAT_NUM_REGEX, "$1.$2").replace(FROM_AND_ABOVE_REGEX, '"$1"-"inf"').replace(FROM_UP_TO_REGEX, '"-inf"-"$1"').replace(FROM_FROM_TO_REGEX, '"$1"-"$2"');
  }
  return str.replace(FLOAT_NUM_REGEX, "$1.$2").replace(FROM_SLASH_REGEX, "/").replace(DASH_CHAR_REGEX, " ").toLowerCase();
};
var TO_SEO_REGEX = /[A-Z]/g;
var QUOTE_REGEX = /"/g;
var UP_TO_REGEX = /^-inf-([\d.]+)/;
var AND_ABOVE_REGEX = /^([\d.]+)-inf$/g;
var FROM_TO_REGEX = /^([\d.]+)-([\d.]+)/g;
var FULL_STOP_REGEX = /\./g;
var SLASH_REGEX = /\//g;
var toSEO = (str, isRangeOption) => {
  if (isRangeOption) {
    return str.replace(QUOTE_REGEX, "").replace(UP_TO_REGEX, "up-to-$1").replace(AND_ABOVE_REGEX, "$1-and-above").replace(FROM_TO_REGEX, "$1-to-$2").replace(FULL_STOP_REGEX, "-");
  }
  return str.replace(SLASH_REGEX, "-slash-").replace(SPACE_REGEX, "-").replace(FULL_STOP_REGEX, "-").replace(TO_SEO_REGEX, (letter) => `-${letter.toLowerCase()}`).toLowerCase();
};
var UNDERSCORE_CHAR_REGEX = /_/g;
var PIPE_CHAR_REGEX = /\|/g;
var decodeFacetOption = (opt) => decodeURIComponent(opt).replace(UNDERSCORE_CHAR_REGEX, "-").replace(PIPE_CHAR_REGEX, "/");
var parseIntParam = (param) => {
  const paramAsInt = param && parseInt(param);
  if (typeof paramAsInt === "number" && !isNaN(paramAsInt)) return paramAsInt;
};
var parseSearchTerm = (searchTerm) => decodeURIComponent(searchTerm).replace(DASH_CHAR_REGEX, " ").trim();
var formatSearchTerm = (searchTerm) => encodeURIComponent(searchTerm.replace(SPACE_REGEX, "-"));

// src/plp-url.ts
var parsePLPURL = (url, brand) => new PLPURL2(url, brand);
var PLPURL2 = class {
  constructor(url, brand = DEFAULT_BRAND_SITE) {
    /**
     * the current category and hierarchy of the URL
     *
     * for browse & promo URLs hierarchy is only ever one value
     *
     * @example // browse
     * { id: "technology-televisions", hierarchy: ["technology-televisions"] }
     * @example // search
     * { id: "technology-televisions", hierarchy: ["technology", "technology-televisions"] }
     *
     * @see {@link Category}
     */
    this.category = { id: void 0, hierarchy: [] };
    /**
     * the list of facets and their options which are in the URL
     *
     * @example [{ id: "washLoad", seoId: "wash-load", isRangeFacet: true, options: [{ id: "10-to-12" }] }]
     *
     * @see {@link Facet}
     */
    this.facets = [];
    var _a;
    this.brand = VALID_BRAND_MAP[brand] || DEFAULT_BRAND_SITE;
    const urlObj = new URL(url, FALLBACK_URL_BASE);
    if (EQ_SEARCH_REGEX.test(urlObj.pathname)) {
      urlObj.pathname = urlObj.pathname.replace(EQ_SEARCH_REGEX, "/search/$1");
    }
    const pageTypeMatch = PAGE_TYPE_REGEX.exec(urlObj.pathname);
    if (!((_a = pageTypeMatch == null ? void 0 : pageTypeMatch.groups) == null ? void 0 : _a.type)) throw new Error("invalid plp url");
    this.type = pageTypeMatch.groups.type;
    this.parseURL(urlObj);
  }
  /**
   * whether the URL is a browse URL
   */
  get isBrowse() {
    return this.type === "browse" /* Browse */;
  }
  /**
   * whether the URL is a promo URL
   */
  get isPromo() {
    return this.type === "promo" /* Promo */;
  }
  /**
   * whether the URL is a search URL
   */
  get isSearch() {
    return this.type === "search" /* Search */;
  }
  /**
   * whether the URL is a value deal URL
   */
  get isValueDeal() {
    return this.type === "valuedeal" /* ValueDeal */;
  }
  /**
   * the href of the PLP URL, this builds up the pathname and query params from the current values
   *
   * does not include the origin/domain
   *
   * @example
   * "/browse/technology/brand--apple/operating-system--ios?uf=brand"
   */
  get href() {
    return `${this.buildPathname()}${this.buildQueryParams()}`;
  }
  /**
   * the pathname of the PLP URL, this builds up the pathname from the current values
   *
   * @example
   * "/browse/technology/brand--apple/operating-system--ios"
   */
  get pathname() {
    return this.buildPathname();
  }
  /**
   * the query/search string of the PLP URL, this builds up the query params from the current values
   *
   * @example
   * "?uf=brand"
   */
  get search() {
    return this.buildQueryParams();
  }
  /**
   * the query/search params as an instance of {@link URLSearchParams} of the PLP URL, this builds up the query params from the current values
   */
  get searchParams() {
    return this.getSearchParams();
  }
  /**
   * the href of the PLP URL with all facets removed (except the unfiltered facet), this builds up the pathname and query params from the current values
   *
   * does not include the origin/domain
   *
   * @example
   * "/browse/technology/brand--apple?uf=brand"
   */
  get clearAllHref() {
    var _a;
    const pathname = this.buildPathname({
      facets: !this.unfilteredFacet ? [] : (_a = this.facets) == null ? void 0 : _a.filter((f) => f.id === this.unfilteredFacet)
    });
    const query = this.buildQueryParams({ pageNumber: 1 });
    return `${pathname}${query}`;
  }
  /**
   * function to update the state of the PLP URL
   *
   * @param action the {@link PLPURLAction} to apply to the PLP URL
   * @returns PLP URL for chaining
   *
   * @see {@link PLPURLAction}
   */
  set(action) {
    var _a;
    if (((_a = action.query) == null ? void 0 : _a.pageNumber) !== void 0) {
      this.pageNumber = action.query.pageNumber;
    }
    if (action.facet !== void 0) {
      this.facets = this.updateFacets(action.facet);
      this.pageNumber = 1;
    }
    if (action.category !== void 0) {
      this.category = this.updateCategory(action.category);
      this.pageNumber = 1;
    }
    if (action.query === void 0) return this;
    if (action.query.sortOption !== void 0) {
      this.sortOption = action.query.sortOption;
      this.pageNumber = 1;
    }
    if (action.query.numProducts !== void 0) {
      this.numProducts = action.query.numProducts;
      this.pageNumber = 1;
    }
    if (this.isBrowse && action.query.unfilteredFacet !== void 0) {
      this.unfilteredFacet = action.query.unfilteredFacet;
    }
    return this;
  }
  /**
   * function to update the state of the PLP URL and return the updated href
   *
   * @param action the {@link PLPURLAction} to apply to the PLP URL
   * @returns the updated href
   *
   * @see {@link PLPURLAction}
   */
  setHref(action) {
    return this.set(action).href;
  }
  /**
   * function to generate a href based on the action without updating the state of the PLP URL
   *
   * @param action the {@link PLPURLAction} to apply to the PLP URL
   * @returns the href
   *
   * @see {@link PLPURLAction}
   */
  generateHref(action) {
    const facets = this.updateFacets(action.facet);
    const category = this.updateCategory(action.category);
    const pathname = this.buildPathname({ category, facets });
    const query = this.buildQueryParams(action.query);
    return `${pathname}${query}`;
  }
  parseURL(url) {
    var _a;
    if (url.origin !== FALLBACK_URL_BASE) this.domain = url.hostname;
    const urlParts = url.pathname.replace(PAGE_TYPE_REGEX, "").split("/").map((p) => decodeURIComponent(p).trim()).filter((p) => Boolean(p));
    this.sortOption = (_a = url.searchParams.get(QueryParamKeys.Sort)) != null ? _a : void 0;
    const pageNumberParam = url.searchParams.get(QueryParamKeys.Page);
    this.pageNumber = parseIntParam(pageNumberParam);
    const numProductsParam = url.searchParams.get(QueryParamKeys.NumProducts);
    this.numProducts = parseIntParam(numProductsParam);
    const hasSearchTerm = this.isSearch;
    const hasPageName = this.isPromo || this.isValueDeal;
    const categories = [];
    const facets = {};
    let pageName = void 0;
    let searchTerm = void 0;
    let facetFound = false;
    for (let i = 0; i < urlParts.length; i++) {
      const part = urlParts[i];
      if (!part) continue;
      const facetMatch = FACET_REGEX.exec(part);
      facetFound = Boolean(facetMatch);
      if (!facetFound && hasPageName && !pageName) {
        pageName = part;
        continue;
      }
      if (hasSearchTerm && !facetMatch && i === urlParts.length - 1) {
        const parsedSearchTerm = parseSearchTerm(part);
        searchTerm = parsedSearchTerm || void 0;
        continue;
      }
      if (!facetFound) {
        categories.push(part);
        continue;
      }
      if (facetMatch) {
        const facetOpts = facetMatch.groups.facetOptions.split(FACET_OPTION_SEPARATOR).filter((o) => Boolean(o));
        const isRangeFacet = facetMatch.groups.facetType === RANGE_FACET_SEPARATOR;
        facets[facetMatch.groups.facetId] = {
          id: fromSEOFacetId(facetMatch.groups.facetId),
          seoId: facetMatch.groups.facetId,
          options: facetOpts.map((o) => ({
            id: decodeFacetOption(fromSEOFacetOptionId(o, isRangeFacet)),
            seoId: o
          })),
          isRangeFacet
        };
      }
    }
    this.category = { id: categories[categories.length - 1], hierarchy: categories };
    this.facets = Object.values(facets);
    this.pageName = pageName;
    this.searchTerm = searchTerm;
    const uf = url.searchParams.get(QueryParamKeys.UF);
    this.unfilteredFacet = this.parseUnfilteredFacet(uf);
  }
  parseUnfilteredFacet(uf) {
    var _a, _b;
    if (!((_a = this.facets) == null ? void 0 : _a.length) || ((_b = this.category) == null ? void 0 : _b.id) && !uf || this.type !== "browse" /* Browse */) return;
    if (typeof uf === "string") return fromSEOFacetId(uf);
    const singleValueFacet = this.facets.find((f) => {
      var _a2;
      return ((_a2 = f.options) == null ? void 0 : _a2.length) === 1;
    });
    return singleValueFacet == null ? void 0 : singleValueFacet.id;
  }
  buildPathname({
    category = this.category,
    facets = this.facets
  } = {}) {
    var _a;
    const basePathname = [
      "",
      // to add leading slash
      this.type,
      ...this.pageName ? [this.pageName] : [],
      ...(category == null ? void 0 : category.id) ? [category.id] : [],
      ...(_a = this.buildFacets(facets)) != null ? _a : [],
      ...this.searchTerm ? [formatSearchTerm(this.searchTerm)] : []
    ].join("/");
    return new URL(basePathname, FALLBACK_URL_BASE).pathname;
  }
  buildFacets(facets = this.facets) {
    var _a;
    if (!(facets == null ? void 0 : facets.length)) return facets;
    const sortedFacets = facets.sort((a, b) => a.seoId.localeCompare(b.seoId));
    const facetParts = [];
    for (const f of sortedFacets) {
      const facetId = f.seoId;
      const facetSeparator = f.isRangeFacet ? RANGE_FACET_SEPARATOR : DEFAULT_FACET_SEPARATOR;
      const facetValues = (_a = f.options) == null ? void 0 : _a.map((v) => v.seoId).sort().join(FACET_OPTION_SEPARATOR);
      if (!(facetValues == null ? void 0 : facetValues.length)) continue;
      facetParts.push(`${facetId}${facetSeparator}${facetValues}`);
    }
    return facetParts;
  }
  getSearchParams({
    sortOption = this.sortOption,
    pageNumber = this.pageNumber,
    numProducts = this.numProducts,
    unfilteredFacet = this.unfilteredFacet
  } = {}) {
    return new URLSearchParams(
      [
        [QueryParamKeys.Sort, sortOption !== "relevance" /* Relevance */ && sortOption],
        [
          QueryParamKeys.Page,
          sortOption === this.sortOption && numProducts === this.numProducts && pageNumber && pageNumber > 1 && pageNumber.toString()
        ],
        [QueryParamKeys.NumProducts, numProducts && numProducts !== DEFAULT_NUM_PRODUCTS && numProducts.toString()],
        [QueryParamKeys.UF, this.isBrowse && unfilteredFacet && toSEO(unfilteredFacet)]
      ].filter((p) => Boolean(p[1]))
    );
  }
  buildQueryParams(action) {
    const params = this.getSearchParams(action).toString();
    return params && `?${params}`;
  }
  updateFacets(facetAction) {
    var _a, _b, _c, _d, _e;
    if (facetAction === false) {
      return !this.unfilteredFacet ? [] : this.facets.filter((f) => f.id === this.unfilteredFacet);
    }
    if (!(facetAction == null ? void 0 : facetAction.id) || !facetAction.option) return this.facets;
    const isRangeFacet = RANGE_FACETS.includes(facetAction.id);
    const seoFacetId = toSEO(facetAction.id);
    const hasFacet = (_a = this.facets) == null ? void 0 : _a.some((f) => f.seoId === seoFacetId);
    if (!hasFacet) {
      return [
        ...(_b = this.facets) != null ? _b : [],
        {
          id: facetAction.id,
          seoId: seoFacetId,
          isRangeFacet,
          options: [{ id: facetAction.option, seoId: toSEO(facetAction.option, isRangeFacet) }]
        }
      ];
    }
    const newFacets = [];
    for (const f of this.facets) {
      if (f.seoId !== seoFacetId) {
        newFacets.push(f);
        continue;
      }
      const exists = (_c = f.options) == null ? void 0 : _c.some((o) => o.id === facetAction.option);
      if (!exists) {
        newFacets.push({
          ...f,
          options: [...(_d = f.options) != null ? _d : [], { id: facetAction.option, seoId: toSEO(facetAction.option, isRangeFacet) }]
        });
        continue;
      }
      const newOpts = (_e = f.options) == null ? void 0 : _e.filter((o) => o.id !== facetAction.option);
      if (!(newOpts == null ? void 0 : newOpts.length)) continue;
      newFacets.push({ ...f, options: newOpts });
    }
    return newFacets;
  }
  updateCategory(categoryAction) {
    var _a, _b;
    if (categoryAction === void 0) return this.category;
    if (!categoryAction) return { id: void 0, hierarchy: [] };
    return {
      id: categoryAction,
      hierarchy: !this.isSearch ? [categoryAction] : [...(_b = (_a = this.category) == null ? void 0 : _a.hierarchy) != null ? _b : [], categoryAction]
    };
  }
  /**
   * function to generate a full api url from the current plp url state
   *
   * @param baseURL the base url for the api e.g. `https://www.very.co.uk/api/search-domain/browse`
   * @param opts options for the generator
   * @returns the full api url
   *
   * @example
   * "https://www.very.co.uk/api/search-domain/browse/group_id/technology-televisions?filters%5BscreenType%5D=flat&num_results_per_page=30&page=1&ui=1234"
   */
  generateAPIUrl(baseURL, opts) {
    const trimmedBaseURL = trimTrailingSlash(baseURL);
    const queryParams = [];
    const browseByUF = this.unfilteredFacet && this.isBrowse && (!this.category.id || this.category.id === "all" || IMPORTANT_UF.includes(this.unfilteredFacet));
    let ufFilter = void 0;
    for (const facet of this.facets) {
      for (const facetOption of facet.options) {
        if (browseByUF && facet.id === this.unfilteredFacet) {
          ufFilter != null ? ufFilter : ufFilter = `${replaceSpecialChars(facet.id || "")}/${replaceSpecialChars(facetOption.id)}`;
          continue;
        }
        queryParams.push(`filters[${replaceSpecialChars(facet.id || "")}]=${replaceSpecialChars(facetOption.id)}`);
      }
    }
    const groupId = getGroupId(this);
    if (groupId) queryParams.push(`${APIQueryParamKeys.GroupId}=${groupId}`);
    queryParams.push(`${APIQueryParamKeys.NumProducts}=${this.numProducts || DEFAULT_NUM_PRODUCTS}`);
    queryParams.push(`${APIQueryParamKeys.Page}=${this.pageNumber || 1}`);
    const sortOpts = getSortOptions(this.sortOption);
    if (sortOpts) {
      queryParams.push(`${APIQueryParamKeys.SortBy}=${sortOpts.sortBy}`);
      queryParams.push(`${APIQueryParamKeys.SortOrder}=${sortOpts.sortOrder}`);
    }
    const customerId = getCustomerId(opts == null ? void 0 : opts.customerId);
    if (customerId) queryParams.push(`${APIQueryParamKeys.UI}=${customerId}`);
    const filterPart = ufFilter || getFilterPart(this);
    return encodeSpecialChars(`${trimmedBaseURL}/${filterPart}?${queryParams.join("&")}`);
  }
  /**
   * @returns the href from the current state
   *
   * @example
   * const plpURL = parsePLPURL("/browse/brand--apple", "very");
   * return `${plpURL}`;
   */
  toString() {
    return this.href;
  }
};

export { APIQueryParamKeys, BRAND_DOMAIN_MAP, BROWSE_REGEX, Brand, DASH_CHAR_REGEX, DEFAULT_BRAND_SITE, DEFAULT_FACET_SEPARATOR, DEFAULT_NUM_PRODUCTS, EQ_SEARCH_REGEX, FACET_OPTION_SEPARATOR, FACET_REGEX, FALLBACK_URL_BASE, IMPORTANT_UF, PAGE_TYPE_REGEX, PLPURL2 as PLPURL, PROMO_REGEX, PageType, QueryParamKeys, RANGE_FACETS, RANGE_FACET_SEPARATOR, SEARCH_REGEX, SLASH_CHAR_REGEX, SPACE_REGEX, Sort, VALID_BRAND_MAP, decodeFacetOption, encodeSpecialChars, formatSearchTerm, fromSEOFacetId, fromSEOFacetOptionId, getCustomerId, getFilterName, getFilterPart, getFilterValue, getGroupId, getSortOptions, parseIntParam, parsePLPURL, parseSearchTerm, replaceSpecialChars, toSEO, trimTrailingSlash };
//# sourceMappingURL=plp-url.js.map
//# sourceMappingURL=plp-url.js.map